export const INDIA_STATE_CODES = {
    "Andhra Pradesh": 28,
    "Arunachal Pradesh": 12,
    "Assam": 18,
    "Bihar": 10,
    "Chhattisgarh": 22,
    "Goa": 30,
    "Gujarat": 24,   // ✅ YOU WANTED THIS
    "Haryana": 6,
    "Himachal Pradesh": 2,
    "Jharkhand": 20,
    "Karnataka": 29,
    "Kerala": 32,
    "Madhya Pradesh": 23,
    "Maharashtra": 27,
    "Manipur": 14,
    "Meghalaya": 17,
    "Mizoram": 15,
    "Nagaland": 13,
    "Odisha": 21,
    "Punjab": 3,
    "Rajasthan": 8,
    "Sikkim": 11,
    "Tamil Nadu": 33,
    "Telangana": 36,
    "Tripura": 16,
    "Uttar Pradesh": 9,
    "Uttarakhand": 5,
    "West Bengal": 19,
    "Delhi": 7,
    "Jammu and Kashmir": 1,
    "Ladakh": 37,
    "Puducherry": 34,
    "Chandigarh": 4,
    "Dadra and Nagar Haveli and Daman and Diu": 26,
    "Andaman and Nicobar Islands": 35
};

export const TRANSFORM_TYPE = [
    {
        id: 1,
        label: "PLATE",
        value: "PLATE"
    },
    {
        id: 2,
        label: "PIPE",
        value: "PIPE"
    },
    {
        id: 3,
        label: "BAR",
        value: "BAR"
    },
    {
        id: 4,
        label: "SHEET",
        value: "SHEET"
    }
]

export const STOCK_UOM_TYPE = [
    {
        id: 1,
        label: "QTY",
        value: "QTY"
    },
    {
        id: 2,
        label: "LENGTH",
        value: "LENGTH"
    },
    {
        id: 3,
        label: "AREA",
        value: "AREA"
    },
    {
        id: 4,
        label: "WEIGHT",
        value: "WEIGHT"
    }
]

export const MATERIAL_ISSUE_TYPE = [
    {
        id: 1,
        lable: "CONSUMABLE",
        value: "CONSUMABLE"
    },
    {
        id: 2,
        label: "LOT",
        value: "LOT"
    },
    {
        id: 3,
        lable: "PIECE",
        value: "PIECE"
    }
]

export const CONSUMABLE_LIST = [
    {
        label: "CONSUMABLE",
        value: "CONSUMABLE"
    },
    {
        label: "LOT",
        value: "LOT"
    },
    {
        label: "PIECE",
        value: "PIECE"
    }
]